import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-polish',
  templateUrl: './section-polish.component.html',
  styleUrls: ['./section-polish.component.css']
})
export class SectionPolishComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
